
import HeadTittle from "../../../../../../../components/HeadTittle";
import DivContainerBody from "../../../../../../../components/DivContainerBody";
import DividerWithText from "../../../../../../../components/DividerWithText";
import ActiveScheduleStep from "../../../../../Traffic/Manage/SubComponents/ActiveSheduleStep";
import DefineAreaStep from "../../../../../Traffic/Manage/SubComponents/DefineAreaStep";
import DetailsStep from "./DetailsStep";
import {UpdateGeofenceAttendanceApp} from "../Functionality/UpdateGeofenceAttendanceApp";

/**
 * Author: Karen Yunuen Pozos Arias
 * Job Title: Fullstack
 * Email: kpozos@ibl.mx
 * Created At: 14/07/2026
 */

const DetailsGeofenceAttendance  = ({ disabled }) => {
    const {
        t,
        item,
        emptyFields,
        setItem,
        setDayArray,
        dayArray,
        handleChange,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        center,
        handleOnBack,
        isCloseTimeInvalid,
        selectedList,
        setSelectedList,
    } = UpdateGeofenceAttendanceApp();

    return (
        <>
            <HeadTittle name={'details'} onBack={handleOnBack}>
            </HeadTittle>
            <DivContainerBody>
                <div className='col-12 mb-4'>
                    <DividerWithText title={t('details')} />
                </div>

                <DetailsStep
                    t={t}
                    item={item}
                    setItem={setItem}
                    disabled={disabled}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                />
                <div className='col-12 my-4'>
                    <DividerWithText title={t('active_schedule')} />
                </div>

                <ActiveScheduleStep
                    item={item}
                    t={t}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    dayArray={dayArray}
                    setDayArray={setDayArray}
                    disabled={disabled}
                    isCloseTimeInvalid={isCloseTimeInvalid}
                    formatValue={false}
                />
                <div className='col-12 mb-4'>
                    <DividerWithText title={t('geofence_area')} />
                </div>
                <div className={'col-12 mb-4'}>
                    <DefineAreaStep
                        t={t}
                        geofences={geofences}
                        setGeofences={setGeofences}
                        latitude={latitude}
                        setLatitude={setLatitude}
                        longitude={longitude}
                        setLongitude={setLongitude}
                        emptyFields={emptyFields}
                        item={item}
                        setItem={setItem}
                        center={center}
                        disabled={disabled}
                    />
                </div>
            </DivContainerBody>
        </>
    );
};
export default DetailsGeofenceAttendance
